import React from 'react';
import { AlertCircle } from 'lucide-react';

const AnonymizeModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-start mb-4">
          <AlertCircle className="text-amber-500 mr-3 flex-shrink-0 mt-1" size={24} />
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Anonymization Required</h3>
            <p className="text-gray-700">These patient notes should be anonymized before analysis. Please ensure all personally identifiable information has been removed.</p>
          </div>
        </div>
        <p className="text-gray-600 mb-6 text-sm">Click "Yes, Proceed" to continue with the analysis.</p>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg font-semibold hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-teal-600 text-white py-2 rounded-lg font-semibold hover:bg-teal-700"
          >
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnonymizeModal;

